import React from 'react';
import PropTypes from 'prop-types';

const CandlestickShape = (props) => 
    {
      const {
        x, width,
        open, close, high, low, highestHigh, lowestLow, 
        background,
        enableShadow
      } = props;

      const getYPosition = (v) => {
        const valueRange = highestHigh - lowestLow;
        const percentageFromBottom = (v - lowestLow) / valueRange;
        // Calculate Y position - subtract from chart height since SVG coords are top-down
        return background.height - (percentageFromBottom * background.height) + background.y;
      };

      // Fallback if data is undefined
      if (!open || !high || !low || !close) {
        return null;
      }

      const openY = getYPosition(open);
      const closeY = getYPosition(close);
      const barStart = Math.min(openY, closeY);
      const barEnd = Math.max(openY, closeY);
      const barHeight = Math.abs(openY - closeY);
      const highY = getYPosition(high);
      const lowY = getYPosition(low);
      const isPositive = close >= open;
      const bodyColor = isPositive ? "#26a69a" : "#ef5350"; // professional teal/red
      const wickColor = "#000000"; // black wicks

      // Ensure a minimum visible width for readability (especially on mobile)
      const minBodyWidth = 4;
      const effectiveWidth = Math.max(width, minBodyWidth);
      const xOffset = x - (effectiveWidth - width) / 2;

      return (
        <g>
          {/* Candle body */}
          <rect
            x={xOffset}
            y={barStart}
            width={effectiveWidth}
            height={barHeight}
            fill={bodyColor}
            style={{ fill: bodyColor, fillOpacity: 1.0 }}
            rx={1.5}
            ry={1.5}
            filter={enableShadow ? "url(#tvCandleShadow)" : undefined}
          />
        {/* Wick 1*/}
        <line
          x1={xOffset + effectiveWidth / 2}
          x2={xOffset + effectiveWidth / 2}
          y1={barStart}
          y2={highY}
          stroke={wickColor}
          style={{ stroke: wickColor, strokeOpacity: 1.0 }}
          strokeWidth={1}
        />
        {/* Wick 2*/}
        <line
          x1={xOffset + effectiveWidth / 2}
          x2={xOffset + effectiveWidth / 2}
          y1={barEnd}
          y2={lowY}
          stroke={wickColor}
          style={{ stroke: wickColor, strokeOpacity: 1.0 }}
          strokeWidth={1}
        />
        </g>
      );
    };

CandlestickShape.propTypes = {
  x: PropTypes.number,
  width: PropTypes.number,
  open: PropTypes.number,
  close: PropTypes.number,
  high: PropTypes.number,
  low: PropTypes.number,
  highestHigh: PropTypes.number,
  lowestLow: PropTypes.number, 
  //background
  };

export default CandlestickShape;